import { render, staticRenderFns } from "./ChangeLogForm.vue?vue&type=template&id=6bcfb973&"
import script from "./ChangeLogForm.vue?vue&type=script&lang=js&"
export * from "./ChangeLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports